import { FeatureFlagsActions, FeatureFlagsActionType } from 'dashboard/redux/actions/feature-flags';
import { FeatureFlagsMap } from 'lib/interfaces/feature-flags';

export interface FeatureFlagsState {
  featureFlags: FeatureFlagsMap;
  featureFlagsFromServer: FeatureFlagsMap;
  featureFlagsOverrides: FeatureFlagsMap;
}

const initialFeatureFlagsState: FeatureFlagsState = {
  featureFlags: {},
  featureFlagsFromServer: {},
  featureFlagsOverrides: {},
};

export default (
  state: FeatureFlagsState = initialFeatureFlagsState,
  action: FeatureFlagsActions,
) => {
  switch (action.type) {
    case FeatureFlagsActionType.SaveFeatureFlags: {
      return {
        ...state,
        featureFlagsFromServer: action.payload.featureFlags,
        featureFlags: {
          ...action.payload.featureFlags,
          ...state.featureFlagsOverrides,
        },
      };
    }
    case FeatureFlagsActionType.SaveOverrideFeatureFlags: {
      return {
        ...state,
        featureFlagsOverrides: action.payload.featureFlagsOverrides,
        featureFlags: {
          ...state.featureFlagsFromServer,
          ...action.payload.featureFlagsOverrides,
        },
      };
    }

    default:
      return state;
  }
};
